import {
  Button,
  ErrorMessage,
  Input,
  success,
  useCustomForm,
  useEffect,
} from "@";
import { useUpdateStatusMutation } from "../api/mutations/index.ts";
import {
  updateStatusDefaultValues,
  updateStatusSchema,
} from "../lib/validation.ts";
import type { UpdateStatusFormValues, VerifySearchValues } from "../types.ts";

interface RejectOrdersModalProps {
  ids: number[];
  onSuccess: () => void;
  searchValues: VerifySearchValues;
  selectingAll: boolean;
}

const RejectOrdersModal = ({
  ids,
  onSuccess,
  searchValues,
  selectingAll,
}: RejectOrdersModalProps) => {
  const {
    watch,
    errors,
    reset,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(updateStatusDefaultValues, updateStatusSchema);

  const updateStatusMutation = useUpdateStatusMutation();

  // Handle form submission
  const submit = async (form: UpdateStatusFormValues) => {
    await updateStatusMutation.mutateAsync({
      verificationStagesIds: form.verificationStagesIds,
      isAccepted: false,
      comment: form.comment || undefined,
      searchValues,
      selectingAll,
    });
    success("تم تعديل حالة الطلبات بنجاح");
    reset();
    onSuccess();
  };

  // Set the verification IDs when the component mounts or ids change
  useEffect(() => {
    setValue("verificationStagesIds", ids);
  }, [ids, setValue]);

  return (
    <form onSubmit={handleSubmit(submit)} className="p-2 md:p-5">
      {ids?.length === 0 && (
        <ErrorMessage className="mb-5" value="رجاء تحديد طلب واحد على الاقل" />
      )}

      <Input
        label="سبب الرفض"
        type="textarea"
        error={!watch("isAccepted") && errors.comment}
        star={watch("isAccepted")}
        input={register("comment")}
        disabled={ids?.length === 0}
      />

      {ids?.length > 0 && (
        <Button
          type="submit"
          className="mt-5 w-full"
          title="رفض الطلبات"
          isLoading={isSubmitting}
        />
      )}
    </form>
  );
};

export default RejectOrdersModal;
